import { render, staticRenderFns } from "./chicang1.vue?vue&type=template&id=1dd442ca&scoped=true&"
import script from "./chicang1.vue?vue&type=script&lang=js&"
export * from "./chicang1.vue?vue&type=script&lang=js&"
import style0 from "./chicang1.vue?vue&type=style&index=0&id=1dd442ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd442ca",
  null
  
)

export default component.exports